import columns from '../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Sender', 'sender'),
        new TextColumn('Receiver', 'receiver'),
        new TextColumn('Sending mailbox', 'sendingMailbox'),
        new TextColumn('Receiving mailbox', 'receivingMailbox'),
        new TextColumn('INTREF', 'intref'),
        new TextColumn('MESREF', 'mesref'),
        new TextColumn('Message type', 'messageType'),
        new DateTimeColumn('Preparation date', 'preparationDate'),
        new TextColumn('On network - preparation date', 'onNetworkPreparationDate'),
        new DateTimeColumn('On network date', 'onNetworkDate'),
        new TextColumn('Translator in - on network date', 'translatorInOnNetworkDate'),
        new DateTimeColumn('Translator in date', 'translatorInDate'),
        new TextColumn('Translator out - translator in date', 'translatorOutInDate'),
        new DateTimeColumn('Translator out date', 'translatorOutDate'),
        new TextColumn('Database load - translator out date', 'databaseLoadTranslatorOutDate'),
        new DateTimeColumn('Database load date', 'databaseLoadDate'),
        new TextColumn('Database load - preparation date', 'databaseLoadPreparationDate'),
      ],
    },
  ];
};
